// Copied to https://github.com/DietLabs/byAnn-landings/blob/master/src/SaleProduct/SaleProductContext.js
export const SALE_SOURCES_NAMESPACE = 'saleSources';
